/* eslint-disable vue/component-definition-name-casing */
//test
import Vue, { h, defineComponent, VNode } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, container, pageTitle } from '@/ui/components';
//@ts-ignore
import { BIcon } from 'buefy/dist/esm/icon';
import { library } from '@fortawesome/fontawesome-svg-core';
// internal icons
import { faCheck, faUpload } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ConfigProgrammatic } from 'buefy';
// @ts-ignore
import { BuefyConfig } from 'buefy/types/components.d';

library.add(faCheck, faUpload, faTrashAlt);
Vue.component('font-awesome-icon', FontAwesomeIcon);

/**
 * used to test quickly some components
 */
export const TestIconPage = defineComponent({
  name: 'TestIconPage',
  setup() {
    // needed for buefy
    ConfigProgrammatic.setOptions({
      defaultIconPack: 'far',
      defaultIconComponent: 'font-awesome-icon',
    } as BuefyConfig);

    return function render(): VNode {
      return container([
        pageTitle(t('test page')),
        box([
          h('div', { class: 'columns has-text-centered' }, [
            'TEST!',
            h(BIcon, {
              props: {
                pack: 'far',
                icon: 'trash-alt',
              },
            }),
            h(BIcon, {
              props: {
                pack: 'far',
                icon: 'check',
              },
            }),
            h(BIcon, {
              props: {
                pack: 'far',
                icon: 'upload',
              },
            }),
          ]),
        ]),
      ]);
    };
  },
});
